export default __webpack_public_path__ + "static/media/fauna-roadmap-results.9fab9b7d.png";